import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { BaseApiService } from '../../../core/base-api.service';

export interface TerminalSession {
  close: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class TerminalService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly oidc = inject(OidcSecurityService);

  private get baseUrl(): string {
    return `${this.coreApiUrl}/api/v1/device`;
  }

  openStream(
    clientId: string,
    senderId: string,
    onMessage: (data: string) => void,
    onError: (err: unknown) => void
  ): TerminalSession {
    const abortController = new AbortController();
    const url = `${this.baseUrl}/${clientId}/terminal/stream?senderId=${senderId}`;

    let accessToken = '';
    this.oidc.getAccessToken().subscribe(token => {
      accessToken = token ?? '';
    }).unsubscribe();

    fetchEventSource(url, {
      signal: abortController.signal,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      onmessage(event) {
        onMessage(event.data);
      },
      onerror(err) {
        onError(err);
        throw err; // stop retrying on error
      },
    });

    return { close: () => abortController.abort() };
  }

  sendCommand(clientId: string, senderId: string, command: string, commandSequence: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${clientId}/terminal/command`, {
      clientId,
      command,
      senderId,
      commandSequence,
    });
  }
}
